WiseMetering.Collection.Leads = WiseMetering.Collection.extend({
    hasOrganization: false,
    model: WiseMetering.Model.Lead,
    url: '/leads'
});
